module.exports = __webpack_public_path__ + "img/domain-working-in-lap.41de2843.png";